import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { AuthProvider } from '@/components/auth/AuthProvider';

export const Route = createRootRoute({
  component: () => (
    <AuthProvider>
      <Outlet />
      {/* Bottom-right so the floating badge doesn't sit on top of the sidebar's
          user menu / logout in the bottom-left corner. */}
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </AuthProvider>
  ),
});
